import React from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import MyTasksContent from './MyTasksContent';
import SeeAllWhite from './SeeAllWhite';
import { getProjectState } from '../../features/project/selectors';

const useStyles = makeStyles({
  titleStyle: {
    background: 'linear-gradient(225deg, #00308C 0%, #002366 100%)',
    borderRadius: '4px 4px 0px 0px',
  },
});

const ROWS_PER_PAGE_OPTIONS = [5, 10, 15];

/**
 * Dashboard's full-width "My Work" card — replaces the old Upcoming and My Work widgets with
 * the same charts/tabs/filter/view-toggle/table content as the standalone My Work page, just
 * embedded in a card instead of a full page, defaulting to 5 rows per page instead of 25.
 */
export default function DashboardMyTasksCard() {
  const classes = useStyles();
  const project = useSelector(getProjectState);

  return (
    <Card>
      <CardContent className={classes.titleStyle}>
        <Grid container style={{ justifyContent: 'space-between' }}>
          <Grid item>
            <h2 className="h2" style={{ textAlign: 'left', color: '#FFFFFF', margin: 0 }}>
              My Work
            </h2>
          </Grid>
          <Grid item alignContent="center">
            <SeeAllWhite link={`/main/${project ? `projects/${project.id}/` : ''}my-work`} />
          </Grid>
        </Grid>
      </CardContent>
      <CardContent>
        {/* White charts here, not the page's #FAFAFA: inside this card they sit on white. */}
        <MyTasksContent rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS} chartBackgroundColor="#FFFFFF" />
      </CardContent>
    </Card>
  );
}
